interface IProps {
  cpf: string;
  emptyCpf: string;
  incorrectCpf: string;
}

interface IReturn {
  message: string;
  status: 'Error' | '';
}

const cpfValidation = ({ cpf, emptyCpf, incorrectCpf }: IProps): IReturn => {
  const value = cpf.replace(/\D/g, '');

  if (!value)
    return {
      message: emptyCpf,
      status: 'Error',
    };

  if (value.length !== 11)
    return {
      message: incorrectCpf,
      status: 'Error',
    };

  // CPFs de digito repetido (111.111.111-11 e afins) PASSAM no calculo dos
  // digitos verificadores, entao precisam ser barrados a parte.
  if (/^(\d)\1{10}$/.test(value))
    return {
      message: value === '00000000000' ? emptyCpf : incorrectCpf,
      status: 'Error',
    };

  let Soma;
  let Resto;
  let i;
  Soma = 0;

  for (i = 1; i <= 9; i += 1)
    Soma += parseInt(value.substring(i - 1, i), 10) * (11 - i);
  Resto = (Soma * 10) % 11;

  if (Resto === 10 || Resto === 11) Resto = 0;
  if (Resto !== parseInt(value.substring(9, 10), 10))
    return {
      message: incorrectCpf,
      status: 'Error',
    };

  Soma = 0;
  for (i = 1; i <= 10; i += 1)
    Soma += parseInt(value.substring(i - 1, i), 10) * (12 - i);
  Resto = (Soma * 10) % 11;

  if (Resto === 10 || Resto === 11) Resto = 0;
  if (Resto !== parseInt(value.substring(10, 11), 10))
    return {
      message: incorrectCpf,
      status: 'Error',
    };
  return {
    message: '',
    status: '',
  };
};

export { cpfValidation };
